import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import AuthGuard from './Pages/AuthGuard';
import Login from './Pages/Login';
import { ApiProvider } from './ContextApi/ContextApi';
import AccountRegistration from './Pages/AccountRegistrationForm';
import TestEntry from './Pages/TestEntry';
import PatientList from './Pages/PatientList';
import PatientProfile from './Pages/PatientProfile';
import Dashboard from './Pages/Dashboard';
import SignUp from './Pages/SignUp';
import TemplateSetting from './Pages/TemplateSetting';
import PatientRegistration from './Pages/PatientRegistration';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MonthlyReports from './Pages/Reports/MonthlyReports';
import DailyReports from './Pages/Reports/DailyReports';
import DateRangeReports from './Pages/Reports/DateRangeReports';
import UserLists from './Pages/UserManagement/UserLists';
import Reports from './Pages/Reports/Reports';
import PendingTest from './Pages/PendingTests/PendingTests';
import BillingManager from './Pages/Billing/BillingManager';
import EditLab from './Pages/EditLab/EditLab';

// --- ONBOARDING COMPONENTS ---
import SubscriptionPlans from './Pages/AutoSubscription/SubscriptionPlans';

function App() {
  const [User_Roles, SetUser_Role] = React.useState([]);

  return (
    <>
      <BrowserRouter>
        <ApiProvider>
          <Routes>
            {/* 1. PUBLIC LANDING & ONBOARDING ROUTES */}
             <Route path="/" element={<Login />} />
            <Route path="/subscriptions" element={<SubscriptionPlans />} />
            <Route path="/AccountRegistration" element={<AccountRegistration />} />

            {/* 2. PROTECTED EMR APP ROUTES */}
            <Route
              path="/Home/*"
              element={
                <AuthGuard>
                  <Routes>
                    <Route path="Dashboard" element={<Dashboard />} />
                    <Route path="SignUp" element={<SignUp />} />
                    <Route path="TestEntry" element={<TestEntry />} />
                    <Route path="PatientList" element={<PatientList />} />
                    <Route path="PatientProfile/:id" element={<PatientProfile />} />
                    <Route path="TemplateSetting" element={<TemplateSetting />} />
                    <Route path="PatientRegistration" element={<PatientRegistration />} />
                    <Route path="Month-Reports" element={<MonthlyReports />} />
                    <Route path="Daily-Reports" element={<DailyReports />} />
                    <Route path="DateRange-Reports" element={<DateRangeReports />} />
                    <Route path="User-Management" element={<UserLists />} />
                    <Route path="Reports" element={<Reports />} />
                    <Route path="PendingTest" element={<PendingTest />} />
                    <Route path="labs-Billing" element={<BillingManager />} />
                    <Route path="EditLab" element={<EditLab />} />
                  </Routes>
                </AuthGuard>
              }
            />

            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ApiProvider>
      </BrowserRouter>

      <ToastContainer
        position="top-left"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;